export default __webpack_public_path__ + "static/media/AudienceNetwork.a53b65f9.svg";